import LeadLostApprovalSettingsTab from './lead-lost-approval-settings';

export default LeadLostApprovalSettingsTab;
